import { createContext } from 'react';

import { DeviceInformation } from '@shared/lib/hooks';
import { Db } from '@shared/lib/db';
import { KV } from '@shared/lib/kv';
import InMemoryKV from '@shared/lib/kv/InMemoryKV';
import { BeforeInstallPromptEvent } from '@/constants';

export const AppContext = createContext<AppContextProps>({
	appKey: '',
	lang: '',
	languages: [],
	onLanguageChange: () => {},
	onlineStatus: true,
	device: null,
	isPrinting: false,
	isInstalled: false,
	isSupportInstallPrompt: typeof window.onbeforeinstallprompt === 'object',
	isTouchable: window.matchMedia('(pointer: coarse)').matches,
	kv: new InMemoryKV(),
	baseUrl: '',
	parseGraphQLClientError: () => new Error(''),
});

interface AppContextProps {
	appKey: string;
	lang: string;
	device: DeviceInformation | null;
	languages: Array<string>;
	onLanguageChange: Function;
	isTouchable: boolean;
	onlineStatus: boolean;
	isPrinting: boolean;
	db?: Db;
	isInstalled: boolean;
	isSupportInstallPrompt: boolean;
	deferredPrompt?: BeforeInstallPromptEvent;
	kv: KV;
	baseUrl: string;
	clearCache?: () => Promise<void>;
	parseGraphQLClientError: (err: unknown) => Error;
}
